import useRecipeFilters from './useRecipeFilters';
import useRecipeListQuery from './useRecipeListQuery';
import useRecipeListSync from './useRecipeListSync';
import useRecipeMetadata from './useRecipeMetadata';

export const useRecipes = (initialSortField = 'created_at', initialSortDirection: 'asc' | 'desc' = 'desc') => {
    const {
        allTags,
        allAuthors,
        isLoadingTags,
        isLoadingAuthors,
    } = useRecipeMetadata();
    const {
        selectedTagIds,
        selectedAuthorIds,
        sortField,
        sortDirection,
        handleTagChange,
        handleAuthorChange,
        clearFilters,
        setSortField,
        setSortDirection,
    } = useRecipeFilters(initialSortField, initialSortDirection);
    const {
        allRecipes,
        dailySelectionRecipe,
        setAllRecipes,
        loading,
        loadingMore,
        hasMore,
        isRefreshing,
        loadMore,
        refreshRecipes,
    } = useRecipeListQuery({
        selectedTagIds,
        selectedAuthorIds,
        sortField,
        sortDirection,
    });

    useRecipeListSync({ setAllRecipes });

    return {
        allRecipes,
        dailySelectionRecipe,
        loading,
        loadingMore,
        hasMore,
        isRefreshing,
        loadMore,
        refreshRecipes,
        isLoadingTags,
        isLoadingAuthors,
        allTags,
        selectedTagIds,
        handleTagChange,
        allAuthors,
        selectedAuthorIds,
        handleAuthorChange,
        clearFilters,
        sortField,
        setSortField,
        sortDirection,
        setSortDirection
    };
};
